import {useState,useEffect} from "react";
import {Stack,InputLabel} from '@mui/material';
import {MobileDatePicker} from '@mui/x-date-pickers/MobileDatePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {getLocaleFromLang} from '../../../core/utilities/Utilities.js';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fi';
import 'dayjs/locale/pt-br';

const FilterDate=({dateFilter,setDateFilter,application,executeQuery={current:true}})=>{
    const lang=application.globalData.lang;
    const locale=application.globalData.locale||lang;
    dayjs.locale(locale.toLowerCase());
    const localeText=getLocaleFromLang(application.globalData.lang);
    const [tempDate,setTempDate]=useState({start:dayjs(dateFilter.start),end:dayjs(dateFilter.end)});
    const handleChangeDate=(fieldValue,fieldName)=>{
        if(fieldValue&&!isNaN(fieldValue.$D)){
            executeQuery.current=true;
            setDateFilter(prevState=>({...prevState,[fieldName]:fieldValue.toDate()})); 
        }
    }
    useEffect(()=>{
        setTempDate({start:dayjs(dateFilter.start),end:dayjs(dateFilter.end)});
    },[dateFilter]);

    return (
        <Stack style={{paddingTop:'0px'}} direction={{xs:'column',sm:'row'}} spacing={{xs:1,sm:2,md:2}} sx={{marginRight:'10px'}}>
            <InputLabel style={{color:"black"}} size="normal" focused>{application.getLocale("LabelDateFilter")}</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale.toLowerCase()} localeText={localeText}>
                <MobileDatePicker
                    sx={{marginTop:"0px",marginBottom:"0px",div:{marginBottom:"0px",paddingTop:"0px",paddingBottom:"0px",fontSize:"inherit"},input:{paddingBottom:'0px',paddingTop:'0px'}}}
                    closeOnSelect={false}
                    displayWeekNumber={true}
                    slotProps={{
                        dialog:{disableRestoreFocus:true},
                        actionBar:{
                            actions:['accept','cancel','today'],
                            onCancel:()=>{setTempDate({start: dayjs(dateFilter.start),end:dayjs(dateFilter.end)});}
                        },
                        textField:{
                            margin:"normal",
                            size:"small",
                            variant:"outlined"}}}
                    label={application.getLocale("FieldPlannedDateFrom")}
                    value={tempDate.start}
                    onClose={()=>{setTempDate({start:dayjs(dateFilter.start),end:dayjs(dateFilter.end)});}}
                    onChange={(value)=>{
                        if(value&&value.isValid()){
                            setTempDate(prev=>({...prev,start:value}));
                        }
                    }}
                    onAccept={(value)=>handleChangeDate(value,'start')}/>
                <MobileDatePicker
                    sx={{marginTop:"0px",marginBottom:"0px",div:{marginBottom:"0px",paddingTop:"0px",paddingBottom:"0px",fontSize:"inherit"},input:{paddingBottom:'0px',paddingTop:'0px'}}}
                    format="DD.MM.YYYY"
                    closeOnSelect={false}
                    displayWeekNumber={true}
                    slotProps={{
                        dialog:{disableRestoreFocus:true},
                        actionBar:{
                            actions:['accept','cancel','today'],
                            onCancel:()=>{setTempDate({start: dayjs(dateFilter.start),end:dayjs(dateFilter.end)});}
                        },
                        textField:{
                            margin:"normal",
                            size:"small",
                            variant:"outlined"}}}
                    label={application.getLocale("FieldPlannedDateTo")}
                    value={tempDate.end}
                    onClose={()=>{setTempDate({start:dayjs(dateFilter.start),end:dayjs(dateFilter.end)});}}
                    onChange={(value)=>{
                        if(value&&value.isValid()){
                            setTempDate(prev=>({...prev,end:value}));
                        }
                    }}
                    onAccept={(value)=>handleChangeDate(value,'end')}/>
            </LocalizationProvider>
        </Stack>
    );
}

export default FilterDate;
